"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSpacerStyle = void 0;
const getSpacerStyle = ({
  flexGrow,
  flexShrink,
  flexBasis,
  horizontal,
  vertical,
  maxHorizontal,
  maxVertical,
  minHorizontal,
  minVertical,
  spacingScaleValues
}) => {
  const isFixedSize = horizontal !== undefined || vertical !== undefined;
  return {
    // fixed size spacer by default should not grow or shrink.
    flexGrow: isFixedSize ? flexGrow !== null && flexGrow !== void 0 ? flexGrow : 0 : flexGrow !== null && flexGrow !== void 0 ? flexGrow : 1,
    flexShrink: isFixedSize ? flexShrink !== null && flexShrink !== void 0 ? flexShrink : 0 : flexShrink !== null && flexShrink !== void 0 ? flexShrink : 1,
    flexBasis: isFixedSize ? flexBasis : flexBasis !== null && flexBasis !== void 0 ? flexBasis : 1,
    width: horizontal && spacingScaleValues[horizontal],
    height: vertical && spacingScaleValues[vertical],
    maxWidth: maxHorizontal && spacingScaleValues[maxHorizontal],
    maxHeight: maxVertical && spacingScaleValues[maxVertical],
    minWidth: minHorizontal && spacingScaleValues[minHorizontal],
    minHeight: minVertical && spacingScaleValues[minVertical]
  };
};
exports.getSpacerStyle = getSpacerStyle;